"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MagiclinePaymentService = exports.MAGICLINE_PAYMENT_TOKEN_KEY = exports.MAGICLINE_PAYMENT_INITIAL_TOKEN_KEY = void 0;
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var infrastructure_const_1 = require("@src/const/infrastructure.const");
var input_output_helper_const_1 = require("@src/const/input-output-helper.const");
var input_mapping_const_1 = require("@src/const/input.mapping.const");
var backend_services_1 = require("@src/services/backend-services");
var translation_1 = __importDefault(require("@src/services/translation"));
//export const MAGICLINE_PAYMENT_SESSION_KEY = 'magiclinePaymentSession';
exports.MAGICLINE_PAYMENT_INITIAL_TOKEN_KEY = 'initialMagiclinePaymentToken';
exports.MAGICLINE_PAYMENT_TOKEN_KEY = 'magiclinePaymentToken';
// export const MAGICLINE_PAYMENT_FINION_CUSTOMER_ID_KEY = 'magiclinePaymentFinionCustomerId';
var recurringWidget;
var upfrontWidget;
var paymentWidgetScriptPromise;
var paymentInitialized = false;
var requiresRecurring = false;
var requiresUpfront = false;
function isEnabledForStudio(config) {
    var _a;
    var studioIds = (_a = config.get.magiclinePayments) === null || _a === void 0 ? void 0 : _a.studioIds;
    // An absent or empty list leaves the existing payment flow unchanged.
    return (studioIds === null || studioIds === void 0 ? void 0 : studioIds.length) ? studioIds.includes((0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.studioId)) : undefined;
}
function initMagiclinePayments(recuringPaymentContainer, upfrontPaymentContainer, config) {
    return __awaiter(this, void 0, void 0, function () {
        var enabled, taxId, tokens, recurringSessionToken, upfrontSessionToken, recurringEl, upfrontEl, paymentElementSettings, error_1;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    paymentInitialized = false;
                    enabled = isEnabledForStudio(config);
                    [recuringPaymentContainer, upfrontPaymentContainer].forEach(function (container) {
                        if (enabled !== undefined && (container === null || container === void 0 ? void 0 : container[0]))
                            container[0].style.display = enabled ? '' : 'none';
                    });
                    if (enabled === false) {
                        (_a = recurringWidget === null || recurringWidget === void 0 ? void 0 : recurringWidget.destroy) === null || _a === void 0 ? void 0 : _a.call(recurringWidget);
                        (_b = upfrontWidget === null || upfrontWidget === void 0 ? void 0 : upfrontWidget.destroy) === null || _b === void 0 ? void 0 : _b.call(upfrontWidget);
                        recurringWidget = undefined;
                        upfrontWidget = undefined;
                        requiresRecurring = false;
                        requiresUpfront = false;
                        resetPaymentStorage();
                        return [2 /*return*/];
                    }
                    if (!(recuringPaymentContainer === null || recuringPaymentContainer === void 0 ? void 0 : recuringPaymentContainer.length) && !(upfrontPaymentContainer === null || upfrontPaymentContainer === void 0 ? void 0 : upfrontPaymentContainer.length))
                        return [2 /*return*/];
                    taxId = (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.taxId);
                    console.log('Tax id', taxId);
                    return [4 /*yield*/, getMagiclinePaymentToken((_c = config.get) === null || _c === void 0 ? void 0 : _c.tenantKey, (_d = (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.studioId)) !== null && _d !== void 0 ? _d : 'none', (_e = (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.rateBundleTermId)) !== null && _e !== void 0 ? _e : 'none', (_f = (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AdditionalContractFieldsMapping.membershipId)) !== null && _f !== void 0 ? _f : 'none', config.get.fittecId, taxId)];
                case 1:
                    tokens = _l.sent();
                    if (isEnabledForStudio(config) === false)
                        return [2 /*return*/];
                    resetPaymentStorage();
                    recurringSessionToken = (_g = tokens === null || tokens === void 0 ? void 0 : tokens.recurringToken) === null || _g === void 0 ? void 0 : _g.token;
                    upfrontSessionToken = (_h = tokens === null || tokens === void 0 ? void 0 : tokens.upfrontToken) === null || _h === void 0 ? void 0 : _h.token;
                    recurringEl = recuringPaymentContainer === null || recuringPaymentContainer === void 0 ? void 0 : recuringPaymentContainer[0];
                    upfrontEl = upfrontPaymentContainer === null || upfrontPaymentContainer === void 0 ? void 0 : upfrontPaymentContainer[0];
                    paymentElementSettings = (_k = (_j = config.get) === null || _j === void 0 ? void 0 : _j.checkout) === null || _k === void 0 ? void 0 : _k.magiclinePaymentsElement;
                    requiresRecurring = !!(recurringEl && recurringSessionToken);
                    requiresUpfront = !!(upfrontEl && upfrontSessionToken);
                    if (!(requiresRecurring || requiresUpfront)) return [3 /*break*/, 5];
                    _l.label = 2;
                case 2:
                    _l.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, loadMagiclinePaymentWidgetScript()];
                case 3:
                    _l.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _l.sent();
                    console.error('Magicline payment widget script failed to load', error_1);
                    (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('Payment widget could not be loaded'));
                    return [2 /*return*/];
                case 5:
                    if (recurringEl && recurringSessionToken) {
                        requiresRecurring = true;
                        setElementsHiddenByIds(paymentElementSettings === null || paymentElementSettings === void 0 ? void 0 : paymentElementSettings.hideElementsIfNoRecurringPayment, false);
                        mountMagiclinePaymentWidget(recurringSessionToken, recurringEl, 'recurring', config, function () {
                            if (upfrontEl && upfrontSessionToken) {
                                mountMagiclinePaymentWidget(upfrontSessionToken, upfrontEl, 'upfront', config);
                            }
                        });
                    }
                    else {
                        requiresRecurring = false;
                        setElementsHiddenByIds(paymentElementSettings === null || paymentElementSettings === void 0 ? void 0 : paymentElementSettings.hideElementsIfNoRecurringPayment, true);
                    }
                    if (upfrontEl && upfrontSessionToken) {
                        requiresUpfront = true;
                        setElementsHiddenByIds(paymentElementSettings === null || paymentElementSettings === void 0 ? void 0 : paymentElementSettings.hideElementsIfNoUpfrontPayment, false);
                        mountMagiclinePaymentWidget(upfrontSessionToken, upfrontEl, 'upfront', config, function () {
                            if (recurringEl && recurringSessionToken) {
                                mountMagiclinePaymentWidget(recurringSessionToken, recurringEl, 'recurring', config);
                            }
                        });
                    }
                    else {
                        requiresUpfront = false;
                        setElementsHiddenByIds(paymentElementSettings === null || paymentElementSettings === void 0 ? void 0 : paymentElementSettings.hideElementsIfNoUpfrontPayment, true);
                    }
                    paymentInitialized =
                        !!(requiresRecurring || requiresUpfront) &&
                            (!requiresRecurring || !!recurringWidget) &&
                            (!requiresUpfront || !!upfrontWidget);
                    return [2 /*return*/];
            }
        });
    });
}
function getMagiclinePaymentToken(tenantKey, studioId, termId, membershipId, fittecId, taxId) {
    return __awaiter(this, void 0, void 0, function () {
        var cloudUrl, response, errorDetails, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    cloudUrl = (0, infrastructure_const_1._GetCloudFunctionUrl)(infrastructure_const_1._CloudFunctionTypes.fms) + '/magicline/get-payment-token';
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    return [4 /*yield*/, (0, backend_services_1.betterFetch)(cloudUrl, {
                            headers: { 'Content-Type': 'application/json' },
                            method: 'POST',
                            body: JSON.stringify(__assign({ tenantKey: tenantKey, studioId: studioId, fittecId: fittecId, termId: termId, membershipId: membershipId }, ((taxId === null || taxId === void 0 ? void 0 : taxId.length) ? { taxId: taxId } : {}))),
                        })];
                case 2:
                    response = _a.sent();
                    if (!!response.ok) return [3 /*break*/, 4];
                    return [4 /*yield*/, response.json()];
                case 3:
                    errorDetails = _a.sent();
                    console.error('Payment intent error:', errorDetails);
                    return [2 /*return*/, undefined];
                case 4: return [4 /*yield*/, response.json()];
                case 5: return [2 /*return*/, _a.sent()];
                case 6:
                    e_1 = _a.sent();
                    console.error('Payment intent failed:', e_1);
                    return [2 /*return*/, undefined];
                case 7: return [2 /*return*/];
            }
        });
    });
}
function mountMagiclinePaymentWidget(sessionToken, container, mode, config, onSuccess, onFatalError) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    var existingWidget = mode === 'recurring' ? recurringWidget : upfrontWidget;
    existingWidget === null || existingWidget === void 0 ? void 0 : existingWidget.destroy();
    console.log('Destroying existing', existingWidget, 'widget and remounting it');
    container.innerHTML = '';
    var widget;
    try {
        widget = window.paymentWidget.init({
            userSessionToken: sessionToken,
            environment: (_d = (_c = (_b = (_a = config.get) === null || _a === void 0 ? void 0 : _a.checkout) === null || _b === void 0 ? void 0 : _b.magiclinePaymentsElement) === null || _c === void 0 ? void 0 : _c.environment) !== null && _d !== void 0 ? _d : 'live',
            countryCode: (_h = (_g = (_f = (_e = config.get) === null || _e === void 0 ? void 0 : _e.checkout) === null || _f === void 0 ? void 0 : _f.magiclinePaymentsElement) === null || _g === void 0 ? void 0 : _g.countryCode) !== null && _h !== void 0 ? _h : 'DE',
            locale: (_m = (_l = (_k = (_j = config.get) === null || _j === void 0 ? void 0 : _j.checkout) === null || _k === void 0 ? void 0 : _k.magiclinePaymentsElement) === null || _l === void 0 ? void 0 : _l.locale) !== null && _m !== void 0 ? _m : 'de',
            region: (_r = (_q = (_p = (_o = config.get) === null || _o === void 0 ? void 0 : _o.checkout) === null || _p === void 0 ? void 0 : _p.magiclinePaymentsElement) === null || _q === void 0 ? void 0 : _q.region) !== null && _r !== void 0 ? _r : 'eu-central-1',
            container: container,
            onSuccess: function (token, paymentInstrumentDetails, paymentInstrumentToken) {
                if (isEnabledForStudio(config) === false)
                    return;
                if (mode === 'recurring') {
                    sessionStorage.setItem(exports.MAGICLINE_PAYMENT_TOKEN_KEY, token);
                }
                else {
                    sessionStorage.setItem(exports.MAGICLINE_PAYMENT_INITIAL_TOKEN_KEY, token);
                }
                console.log('Magicline payment succeeded', {
                    mode: mode,
                    paymentRequestToken: token,
                    paymentInstrumentDetails: paymentInstrumentDetails,
                    paymentInstrumentToken: paymentInstrumentToken,
                });
                (0, generator_const_1._HideErrorMessage)();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            },
            onError: function (error) {
                console.error('Magicline payment widget error', {
                    mode: mode,
                    code: error === null || error === void 0 ? void 0 : error.code,
                    message: error === null || error === void 0 ? void 0 : error.message,
                    traceId: error === null || error === void 0 ? void 0 : error.traceId,
                    httpStatus: error === null || error === void 0 ? void 0 : error.httpStatus,
                    error: error,
                });
                var errorMessage = error === null || error === void 0 ? void 0 : error.message;
                if (errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.length) {
                    (0, generator_const_1._ShowErrorMessage)(translation_1.default.t(errorMessage));
                }
                // Important: do not keep retrying the same userSessionToken forever.
                onFatalError === null || onFatalError === void 0 ? void 0 : onFatalError(error);
            },
            styling: (_v = (_u = (_t = (_s = config.get) === null || _s === void 0 ? void 0 : _s.checkout) === null || _t === void 0 ? void 0 : _t.magiclinePaymentsElement) === null || _u === void 0 ? void 0 : _u.styling) !== null && _v !== void 0 ? _v : {
                primaryColor: '#007bff',
                textColorMain: '#e0e0e0ff',
                borderRadius: '4px',
            },
        });
    }
    catch (error) {
        console.error('Magicline widget initialization failed', { mode: mode, error: error });
        onFatalError === null || onFatalError === void 0 ? void 0 : onFatalError(error);
        return;
    }
    if (mode === 'recurring') {
        recurringWidget = widget;
    }
    else {
        upfrontWidget = widget;
    }
    return widget;
}
function resetPaymentStorage() {
    sessionStorage.removeItem(exports.MAGICLINE_PAYMENT_TOKEN_KEY);
    sessionStorage.removeItem(exports.MAGICLINE_PAYMENT_INITIAL_TOKEN_KEY);
}
function validateMagiclinePayments(config) {
    var enabled = isEnabledForStudio(config);
    var recurringDone = !!sessionStorage.getItem(exports.MAGICLINE_PAYMENT_TOKEN_KEY);
    var upfrontDone = !!sessionStorage.getItem(exports.MAGICLINE_PAYMENT_INITIAL_TOKEN_KEY);
    var missing = [];
    if (requiresRecurring && !recurringDone) {
        missing.push('recurring');
    }
    if (requiresUpfront && !upfrontDone) {
        missing.push('upfront');
    }
    return {
        isValid: enabled === undefined ? missing.length === 0 : !enabled || (paymentInitialized && missing.length === 0),
        requiresRecurring: requiresRecurring,
        requiresUpfront: requiresUpfront,
        recurringDone: recurringDone,
        upfrontDone: upfrontDone,
        missing: missing,
    };
}
function setElementsHiddenByIds(ids, hidden) {
    ids === null || ids === void 0 ? void 0 : ids.forEach(function (id) {
        var el = document.getElementById(id);
        if (!el)
            return;
        el.style.display = hidden ? 'none' : '';
    });
}
exports.MagiclinePaymentService = {
    isEnabledForStudio: isEnabledForStudio,
    initMagiclinePayments: initMagiclinePayments,
    getMagiclinePaymentToken: getMagiclinePaymentToken,
    resetPaymentStorage: resetPaymentStorage,
    validateMagiclinePayments: validateMagiclinePayments,
};
var MAGICLINE_PAYMENT_WIDGET_SCRIPT_URL = 'https://widget.payment.sportalliance.com/widget.js';
/** Loads the magicline provided payment script */
function loadMagiclinePaymentWidgetScript() {
    var _a;
    if (typeof ((_a = window.paymentWidget) === null || _a === void 0 ? void 0 : _a.init) === 'function') {
        return Promise.resolve();
    }
    if (paymentWidgetScriptPromise)
        return paymentWidgetScriptPromise;
    paymentWidgetScriptPromise = new Promise(function (resolve, reject) {
        var existingScript = document.querySelector("script[src=\"".concat(MAGICLINE_PAYMENT_WIDGET_SCRIPT_URL, "\"]"));
        var script = existingScript !== null && existingScript !== void 0 ? existingScript : document.createElement('script');
        var cleanup = function () {
            window.clearTimeout(timeoutId);
            script.removeEventListener('load', onLoad);
            script.removeEventListener('error', onError);
        };
        var onLoad = function () {
            var _a;
            cleanup();
            if (typeof ((_a = window.paymentWidget) === null || _a === void 0 ? void 0 : _a.init) === 'function') {
                resolve();
            }
            else {
                script.remove();
                reject(new Error('Magicline payment widget loaded without init function'));
            }
        };
        var onError = function () {
            cleanup();
            script.remove();
            reject(new Error('Magicline payment widget script request failed'));
        };
        var timeoutId = window.setTimeout(onError, 15000);
        script.addEventListener('load', onLoad);
        script.addEventListener('error', onError);
        if (!existingScript) {
            script.src = MAGICLINE_PAYMENT_WIDGET_SCRIPT_URL;
            script.async = true;
            document.head.appendChild(script);
        }
    }).catch(function (error) {
        paymentWidgetScriptPromise = undefined;
        throw error;
    });
    return paymentWidgetScriptPromise;
}
